export const DATE_FORMATS = {
    parse: 'YYYYMMDD',
    timeParse: 'HHmm',
    format: 'DD.MM.YYYY',
    monthYearFormat: 'MM.YYYY',
    timeFormat: 'HH:mm',
    monthYearParse: 'YYYYMM',
    dayOfWeekDayMonthFormat: 'dddd D/MM',
    fullDayDateFormat: 'dddd, D/MM/YYYY',
    dayMonthFormat: 'D MMMM',
    dayMonthYearFormat: 'D MMMM YYYY',
    dayFormat: 'D'
};
